import { map } from 'lodash';
import { PropertyType } from '../../../common';

export const mapEntityToApi = (data: PropertyType): PropertyType => {
	const { form, token, game_id } = data;
	const apiData: PropertyType = {
		sid: token,
		game_id,
		category_ids: map(form.categories, 'value'),
	};

	return apiData;
};
